module.exports = __webpack_public_path__ + "img/new_straightDown_bg.21256326.png";